import { createSelector } from '@ngrx/store';
import { mailboxRegisterSelector } from './mailbox-register.reducer';

export const selectFilters = createSelector(mailboxRegisterSelector, (state) => {
   return state.filters;
});
